import {AbstractPage} from "../AbstractPage";
import {JqueryApp} from "../JqueryApp";

export class AbstractGateway extends AbstractPage {
    constructor(app: JqueryApp) {
        super(app);
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected sendSizeFrameMessage(height: number) {
        if (window.parent === window.self)
            return;
        let targetOrigin = "*"; // send to all windows as we likely navigated in the frame
        window.parent.postMessage({
            'func': 'onVpayFrameSize',
            'data': {height: height},
        }, targetOrigin);
    }
}
